module.exports = __webpack_public_path__ + "static/media/logo-vermelha.e41a2846.png";